class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.exactMatchCheckbox = document.getElementById('exact_match');
    this.tooltipBox = document.getElementById('exact-match-tooltip');
    this.dontShowButton = document.getElementById('dont-show-tooltip');
    this.setupEventListeners();
    this.showTooltip();
    this.checkExactMatchOnLoad();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
    allSearchForms.forEach((form) => form.addEventListener('submit', this.onFormSubmit.bind(this)));
    if (this.dontShowButton) {
      this.dontShowButton.addEventListener('click', this.hideTooltipPermanently.bind(this));
    }
  }

  showTooltip() {
    if (!localStorage.getItem('hideExactMatchTooltip')) {
      if (this.tooltipBox) {
        this.tooltipBox.classList.add('show');
        setTimeout(() => {
          this.tooltipBox.classList.remove('show');
        }, 5000); // Tooltip disappears after 5 seconds
      }
    }
  }

  hideTooltipPermanently() {
    localStorage.setItem('hideExactMatchTooltip', 'true');
    if (this.tooltipBox) {
      this.tooltipBox.classList.remove('show');
    }
  }

  checkExactMatchOnLoad() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('exact_match')) {
      this.exactMatchCheckbox.checked = true;
    }
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onFormSubmit(event) {
    this.allSearchInputs.forEach((input) => {
      const trimmedValue = input.value.trim();
      if (this.exactMatchCheckbox && this.exactMatchCheckbox.checked) {
        if (!trimmedValue.startsWith('"') && !trimmedValue.endsWith('"')) {
          input.value = `"${trimmedValue}"`;
        }
      } else {
        if (trimmedValue.startsWith('"') && trimmedValue.endsWith('"')) {
          input.value = trimmedValue.slice(1, -1);
        }
      }
    });
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
